















































































import { Vue, Component } from 'vue-property-decorator';
import Sticky from 'vue-sticky-directive';
import { forEach, cloneDeep } from 'lodash';
import {
  PartnersApi, Partner, PartnerSchedule, DocumentRequest,
} from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import FoodworksMarket from '@/components/Form/Partner/FoodworksMarket/index.vue';
import ContactInformation from '@/components/Form/Partner/ContactInformation/index.vue';
import RestaurantInformation from '@/components/Form/Partner/RestaurantInformation/index.vue';
import Documents from '@/components/Form/FileUploadForm/Documents/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import PageTitle from '@/components/PageTitle/index.vue';
import PartnerConfirmation from '@/components/Form/PartnerConfirmation/index.vue';
import EmailExistsModal from '@/components/Modal/EmailExistsModal/index.vue';
import Format from '@/util/Format';
import UnitsUtil from '../../../util/UnitUtil';
import PartnerUtil from '../../../util/PartnerUtil';

@Component({
  components: {
    FoodworksMarket,
    ContactInformation,
    RestaurantInformation,
    PrimaryButton,
    TextButton,
    Documents,
    PartnerConfirmation,
    EmailExistsModal,
    PageTitle,
  },
  directives: { Sticky },
})
export default class PartnerInformation extends Vue {
  private toggle: boolean = false;

  private loading: boolean = false;

  private valid = true;

  private lazy = false;

  public snackbar: boolean = false;

  public shouldStick: boolean = true;

  private showPartnerModal: boolean = false;

  private showEmailUseModal: boolean = false;

  private error: string = '';

  public email: string = '';

  private documents: Array<DocumentRequest> | null = null;

  public partnerSchedule: PartnerSchedule = {
    minDaysPerWeek: 0,
    servicableLocations: 1,
    popupPattern: [1, 2, 3, 4, 5],
  }

  private marketInfo: any = {
    market: '',
    partnerType: 'restaurant',
    scoutFirstID: this.userID,
  };

  private contactInfo: any = {
    id: '',
    error: '',
    partnerEmailId: '',
  };

  private restaurantInfo: any = {
    name: '',
    address: {
      address: '',
      city: '',
      state: '',
      zip: '',
      country: 'USA',
    },
    website: '',
    businessNumber: {
      phone: '',
    },
    cuisineTypes: [],
    seatingCapicity: '',
    deliveryPartners: [],
    mobileOperations: [],
    foodPrepLocation: [],
    foodPrepLocOther: [],
    auditFormId: '',
    scoutUserID: this.userID,
  };

  // returns the Scout Id
  get userID() {
    return UserModule.userId;
  }

  public onCancel() {
    this.showPartnerModal = false;
    this.showEmailUseModal = false;
  }

  public async onSave() {
    if ((this.$refs.form as any).validate()) {
      if (!this.contactInfo.error) {
        try {
          this.loading = true;
          if (this.contactInfo.id) {
            const email = await PartnerUtil.getPartnerEmailById(this.contactInfo.id);
            if (email && email.length > 0) {
              this.contactInfo.partnerEmailId = email;
              this.showPartnerModal = true;
            }
          }
        } catch (error) {
          console.log('err', error);
        }
        this.loading = false;
      }
      this.showPartnerModal = true;
    } else {
      forEach((this.$refs.form as any).inputs, (e) => {
        if (e.hasError) {
          (document.getElementById(e.id) as HTMLDivElement).scrollIntoView();
          return false;
        }
        return true;
      });
    }
  }

  public async onSubmitPartner() {
    try {
      this.loading = true;
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        if (this.restaurantInfo.businessNumber.phone) {
          const { phone } = this.restaurantInfo.businessNumber;
          this.restaurantInfo.businessNumber.phone = Format.CheckMaskNumber(phone);
        } else {
          this.restaurantInfo.businessNumber.phone = Number(
            this.restaurantInfo.businessNumber.phone,
          );
        }

        const locationFood = [];
        let locationFoodOther = '';
        if (this.restaurantInfo.foodPrepLocation) {
          const location = this.restaurantInfo.foodPrepLocation;
          if (location === 'Others') {
            locationFoodOther = this.restaurantInfo.foodPrepLocOther;
          }
          locationFood.push(this.restaurantInfo.foodPrepLocation);
        }

        const cuisines: any = [];
        cuisines.push(this.restaurantInfo.cuisineTypes);

        const partnerUser: Partner = {
          marketId: this.marketInfo.market,
          type: this.marketInfo.partnerType,
          scoutUserId: this.restaurantInfo.scoutUserID,
          name: this.restaurantInfo.name,
          address: this.restaurantInfo.address,
          website: this.restaurantInfo.website,
          businessNumber: this.restaurantInfo.businessNumber,
          cuisineTypes: cuisines,
          seatingCapicity: this.restaurantInfo.seatingCapicity,
          deliveryPartners: this.restaurantInfo.deliveryPartners,
          mobileOperations: this.restaurantInfo.mobileOperations,
          foodPrepLocation: locationFood,
          foodPrepLocOther: locationFoodOther,
          ownerUserId: this.contactInfo.id,
          schedule: this.partnerSchedule,
          auditFormId: this.restaurantInfo.auditFormId,
        };

        try {
          const api = new PartnersApi(AppModule.apiConfig);
          const partner: any = await api.createPartner(
            partnerUser,
          );
          let message = 'Restaurant name added';
          if (partner && this.restaurantInfo) {
            const { name } = this.restaurantInfo;
            message = `${name} added`;
          }
          this.$router.push({ name: 'partners', params: { message } });
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err && err.error) {
        this.contactInfo.error = err.error;
        this.error = err.error;
        if (err.code === 409) {
          this.showPartnerModal = false;
          this.showEmailUseModal = true;
        }
      }
    }
    this.loading = false;
  }

  // open exists email modal
  public onSaveExistsEmail() {
    this.showEmailUseModal = false;
    (document.getElementById('email') as HTMLDivElement).scrollIntoView();
    this.email = cloneDeep(this.contactInfo.email);
  }

  public async cancel() {
    this.$router.push('/partners');
  }
}
